// CONSTANTS are all caps.
const NS = 'ProductDetailsPage';
const CLS = 'productDetailsPage';
const PG = '.' + CLS + '-';
const CLS_LIST_ADDED = 'has-added';
const CLS_INVISIBLE = 'invisible';
const CLS_BUNDLES = CLS + '-bundles';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadPg.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import slick from 'slick-carousel';
import * as utils from '../../../../global/js/utils';
import * as wishlist from '../../../../global/js/wishlist';
import * as giftRegistry from '../../../../global/js/giftRegistry';
import * as Api from '../../../../global/js/api';
import {loadNotifications} from '../../../widgets/notifications/js/loadWg';
import zoom from 'jquery-zoom';
import Handlebars from 'handlebars';
import '../../../../global/helpers/obj';
import * as dataLayer from '../../../../global/js/dataLayer';
import List from 'list.js';
import {addToCart} from '../../../../global/js/cart';

export class ProductDetailsPage {
	constructor($el) {
		// $el is the page node return by the loadProductDetailsPage function
		this.$el = $el;
		this.$pg = $($el);
		// this.currentSize = '';
		// this.currentColor = '';
		this.currentVariant = {
			size: '',
			color: '',
		};
		this.isBundles = this.$pg.hasClass(CLS_BUNDLES);
	}

	init() {
		window.productData = {};
		this.firstRun = true;
		this.setProductDetailsPage();
		this.initFormValidationConstraints();
		this.setImageViewer();
		this.setReviews();
		this.initBundlesQtyButtons();
		let fitAnalytics = window.fitAnalyticsData;
		if (fitAnalytics && productDetailsJson) {
			fitAnalytics.operations.addToCart = (productId, sizeDescription) => {
				// variantId
				if (!sizeDescription && productDetailsJson.variants) {
					let variantSelected = productDetailsJson.variants.find((v) => v.formattedCode === productId);
					if (variantSelected) this.addToBag(variantSelected.code);
				} else {
					// productId
					if (productDetailsJson.colors) {
						let listItems = productDetailsJson.colors.items;
						let itemSelected = listItems.find((item) => item.productCode.includes(productId));
						if (itemSelected && itemSelected.sizes) {
							let sizeSelected = itemSelected.sizes.items.find((sz) => sz.sizeDescription === sizeDescription );
							if (sizeSelected) this.addToBag(sizeSelected.sku, sizeDescription);
						}
					}
				}
			};
		}
	}

	setProductDetailsPage() {
		// show spinners
		$('.loading-spinner').addClass('is-active');
		// Add Some logic here
		let That = this;
		let $pg = $(this.$el);
		That.price = {};
		That.producItemInfo = {};

		// let $slider = $pg.find(PG + 'imgSlider');
		// let $navs = $pg.find(PG + 'sliderNav');
		// let $options = {
		// 	dots: false,
		// 	arrows: false,
		// 	asNavFor: PG + 'sliderNav',
		// };
		// let $optionsNav = {
		// 	slidesToShow: $pg.find(PG + 'imgSlider').find(PG + 'slide').length,
		// 	dots: false,
		// 	arrows: false,
		// 	asNavFor: PG + 'imgSlider',
		// 	focusOnSelect: true,
		// };

		// $slider.slick($options);
		// $navs.slick($optionsNav);

		// set default product options in case there is only one option
		$pg.find(PG + 'optionsWrapper:not(.d-none)').each(function() {
			let $this = $(this);
			let options = $this.find(PG + 'option');
			if (options.length === 1) {
				options.addClass('is-active is-active-variant');
			}
		});

		That.getProdImgVariations();

		// moved this function call within 'getProdImgVariations' so it waits until the api call complete to set the 'data-variant-code'
		// That.getVariantCode();

		// get clicks on options
		$pg.find(PG + 'option').on('click', function() {
			if (!$(this).hasClass('is-active-variant')) {
				That.wasNotActive = true;
			}
			// keep the current selected size
			That.currentVariant.size = $pg.find(PG + 'option.item-size.is-active.is-active-variant:visible').attr('data-item-description') || '';
			if ($(this).parent().hasClass('colors')) {
				That.currentVariant.color = $(this).attr('data-variant-code');
				// when change the color, if the selected size existed then make the size 'active'
				let sizeNodeList = $pg.find(`[data-parent-itemid="${That.currentVariant.color}"]`).find(PG + 'options').children();
				for (let i=0; i<sizeNodeList.length; i++) {
					if ($(sizeNodeList[i]).attr('data-item-description') == That.currentVariant.size) {
						// keep existing the size selection
						$(sizeNodeList[i]).addClass('is-active');
						$(sizeNodeList[i]).addClass('is-active-variant');
					} else {
						// remove active selection
						$(sizeNodeList[i]).removeClass('is-active');
						$(sizeNodeList[i]).removeClass('is-active-variant');
					}
				}
			} else {
				That.currentVariant.size = $(this).attr('data-item-description');
			}

			let variantCode;
			let curVariantCode = $pg.attr('data-variant-code');

			let desc = $(this).data('itemDescription');
			let wpDetail = $(this).closest(PG + 'content');

			$(this).closest(PG + 'optionsWrapper').find(PG + 'optionText').text(desc);
			$(this).closest(PG + 'optionsWrapper').find(PG + 'option:not(.slide)').removeClass('is-active');

			// cleanup styles
			$(this).closest(PG + 'optionsWrapper').find(PG + 'option').removeClass('is-active-variant');
			$(this).not('.slide').addClass('is-active');
			$(this).addClass('is-active-variant');

			// only do one ajax call

			if ($pg.attr('data-item-type') !== 'colorsize') {
				if ($(this).hasClass('item-size')) {
					variantCode = $(this).data('sku');
				}
			}

			if ($pg.attr('data-item-type') !== 'color' || $pg.attr('data-item-type') !== 'size') {
				variantCode = $(this).data('sku');
			}

			if ($(this).hasClass('has-sizes')) {
				let itemCode = $(this).data('variantCode');
				wpDetail.find('[data-parent-itemid]').addClass('d-none');
				wpDetail.find('[data-parent-itemid="'+ itemCode +'"]').removeClass('d-none');
				variantCode= $pg.find(PG + 'optionsWrapper:not(.d-none) .sizes .is-active-variant').attr('data-sku');
				let sizeTextActive = $pg.find(PG + 'optionsWrapper:not(.d-none) .sizes .is-active-variant').text();
				wpDetail.find('[data-parent-itemid="'+ itemCode +'"]').find(PG + 'optionText').text(sizeTextActive);

				if (!variantCode) {
					variantCode = itemCode;
				}

				// Update fitAnalys
				let fitAnalytics = window.fitAnalyticsData;
				if (fitAnalytics && productDetailsJson) {
					let productCode = $(this).data('productCode');
					let colourCode = $(this).data('colourCode');
					let colourName = $(this).data('itemDescription');
					if (productCode) {
						let prefixProductCode = productCode.match(/^[^_]_/);
						fitAnalytics.currentProductId = productCode.replace(prefixProductCode, '').replace('_00', '') + colourName;
					}
					if (colourCode) {
						let selectedVariant = productDetailsJson.variants.filter((item) => item.code === variantCode)[0];
						if (selectedVariant) {
							fitAnalytics.mainThumbnail = location.origin + selectedVariant.images[0].thumb;
						}
						let selectedItem = productDetailsJson.manufacturedSizes.filter((item) => item.colourCode === colourCode)[0];
						if (selectedItem) {
							fitAnalytics.currentColour = colourName;
							let listSize = selectedItem.sizes;
							let updatedListSize = [];
							for (let i = 0; i < listSize.length; i ++) {
								let sz = {value: listSize[i].value, isAvailable: listSize[i].isAvailable};
								updatedListSize.push(sz);
							}
							fitAnalytics.sizes = updatedListSize;
						}
					}
				}
			}

			$pg.attr('data-variant-code', variantCode);

			// trigger variant changed event on the page dom element
			// trigger variant class change
			// happens only if a different variant is clicked
			// if (!$(this).hasClass('is-active-variant')) {
			// TODO: Refactor
			if ((curVariantCode !== variantCode) || That.wasNotActive) {
				$pg.trigger('variantChanged');
			}
			// }

			// set price
			if (That.saleAvailability !== 'ISONP') {
				That.setPrice();
				That.setAppearanceBundlesVariants();
			}

			That.wasNotActive = false;
		});

		$pg.on('click', '.add-to-cart', function() {
			if (That.saleAvailability === 'ISOOP' || That.saleAvailability === 'ISONP') {
				window.location.assign(That.contactUsPageLink);
			} else {
				That.addToBag();
			}
		});

		// call the product images variation API

		// init options click on the active ones so that variant code gets updated
		$pg.find(PG + 'optionsWrapper:not(.d-none) .is-active-variant').each(function() {
			$(this).trigger('click');
		});

		// get clicks on video thumbs
		$pg.on('click', '.video-player', function() {
			let src = $(this).attr('data-src');
			let video = $pg.find('#popupVideo')[0];
			video.src = src;
			$pg.find('#videoPlayerModal').modal('show');
			video.load();
			video.play();
		});

		$pg.on('hidden.bs.modal', '#videoPlayerModal', function() {
			let video = $pg.find('#popupVideo')[0];
			video.pause();
		});

		$pg.on('click', `.wishlistBtn`, function() {
			That.handleWishlistBtn($(this));
		});

		$pg.on('click', `.addToGiftBtn`, function() {
			if ($(this).hasClass(CLS_LIST_ADDED)) return;
			That.addToGiftRegistry($(this));
		});

		let hasUserAddedReview = $(document).find('#hasUserAddedReview').val();

		if (hasUserAddedReview && (hasUserAddedReview == true || hasUserAddedReview == 'true')) {
			$(document).find('.reviewForm-writeBtn').addClass('has-added').html('Review Added');
		}

		$(document).on('shown.bs.modal', '#reviewFormModal', function() {
			// prefill the email and nickname values if they exist
			let userEmail = $(document).find('#userEmail').val();
			let userNickName = $(document).find('#userNickName').val();
			if (userEmail && userEmail != '') {
				$(this).find('#reviewEmail').val(userEmail);
			}
			if (userNickName && userNickName != '') {
				$(this).find('#reviewName').val(userNickName);
			}
		});

		// $pg.find(`.prod-title`).parent().find('hr:first').css({
		// 	marginTop: '36px',
		// });
	}

	setVisibleProduct() {
		let $pg = $(this.$el);
		let colors = $pg.find(PG + 'options.colors').find(PG + 'option');

		if (colors.length > 0) {
			let $firstColor = colors.first();
			let selVariantCode = $firstColor.data('variant-code');
			let $parentSize = $pg.find(`${PG}optionsWrapper[data-parent-itemid="${selVariantCode}"]`);

			$firstColor.trigger('click');

			if ($parentSize.length > 0) {
				let sizes = $parentSize.find(`${PG}options.sizes .item-size`);

				// if there's only one size option, tick it
				if (sizes.length === 1) {
					sizes.first().trigger('click');
				}
			}
		}
	}

	getProdImgVariations() {
		const That = this;
		const $pg = $(this.$el);
		let itemCode = $pg.data('itemCode');

		let data = {};

		if (typeof productDetailsJson != 'undefined') {
			// Defined globally by BE
			// eslint-disable-next-line no-undef
			data = productDetailsJson;

			That.saleAvailability = data.saleAvailability;
			That.contactUsPageLink = data.contactUsPageLink;
		}

		let res = data;
		let slider = $pg.find(PG + 'imgSlider');
		let thumbs = $pg.find(PG + 'imgThumbs');

		// get display price
		if (res.displayPrice) {
			That.displayPrice = res.displayPrice;
			$pg.find('.productDetailsPage__price-detail').html('<h4>' + res.displayPrice + '</h4>');
		}

		// Price should display "displayPrice"
		// Part Payment options (Laybuy, Afterpay, Humm) shouldn't be displayed
		if (That.saleAvailability === 'ISONP') {
			$pg.find(PG + 'paymentInfo').addClass('d-none');
		}

		// "Add to Cart" button changes to "Contact Us" using
		if (That.saleAvailability === 'ISOOP' || That.saleAvailability === 'ISONP') {
			$pg.find('.add-to-cart').text('Contact Us');
		}

		if (res.paymentInfo) {
			That.paymentInfoInit = res.paymentInfo;
		}

		// main slider is the (res.images)
		if (res.images && res.images.length > 0) {
			for (let i = 0; i < res.images.length; i++) {
				let imgSrc = res.images[i].detail;
				let imgThumbSrc = res.images[i].thumb;
				let imgZoomSrc = res.images[i].zoom;
				let alt = res.images[i].alt || res.title || '';
				let videoSrc = res.images[i].video || '';

				let slide = `
					<div class="${CLS}-slide" ${i === 0 ? 'itemprop="image"' : ''}>
						${videoSrc ? '<span class="icon-play"></span>' : ''}
						<img data-zoom-image="${imgZoomSrc}" src="${imgSrc}" alt="${alt}"
							${videoSrc ? 'data-video-src="' + videoSrc + '"' : ''}
						/>
					</div>
				`;

				let thumb = `
					<div class="${CLS}-thumb"
						${videoSrc ? 'data-video-src="' + videoSrc + '"' : ''}
					>
						${videoSrc ? '<span class="icon-play"></span>' : ''}
						<img src="${imgThumbSrc}" alt="${alt}"
							${videoSrc ? 'data-video-src="' + videoSrc + '"' : ''}
						/>
					</div>
				`;

				slider.append(slide);
				thumbs.append(thumb);
			}

			// generic slick options
			let $sliderOptions = {
				dots: false,
				arrows: true,
				asNavFor: PG + 'imgThumbs',

			};

			let $thumbsOptionsNav = {
				slidesToShow: $pg.find(PG + 'imgSlider').find(PG + 'slide').length,
				dots: false,
				arrows: false,
				asNavFor: PG + 'imgSlider',
				focusOnSelect: true,

			};

			slider.slick($sliderOptions);
			thumbs.slick($thumbsOptionsNav);
		}

		// get videos for the current variant
		if (res.videos && res.videos.length > 0) {
			for (let i = 0; i < res.videos.length; i++) {
				let videoSrc = res.videos[i].source;
				let thumbSrc = res.videos[i].thumb || res.images[0].thumb;
				let alt = res.videos[i].alt || res.title || '';

				let videoThumb = `
					<div class="${CLS}-videoThumb video-player" data-src="${videoSrc}">
						<img src="${thumbSrc}" alt="${alt}" />
						<span class="icon-play"><span>
					</div>
				`;

				if (thumbs.find('.slick-track').length > 0) {
					thumbs.find('.slick-track').prepend(videoThumb);
				} else {
					thumbs.prepend(videoThumb);
				}

				thumbs.append(`<div class="clearfix"></div>`);
			}
		}

		// if we have variants, we will loop through them and get the slider ready for each variant
		if (res.variants && res.variants.length > 0) {
			// loop through variants
			for (let i = 0; i < res.variants.length; i++) {
				let variantVideos = res.variants[i].videos;
				let variantCode = res.variants[i].code;
				let variantImages = res.variants[i].images;
				let variantPrice = res.variants[i].price;
				let priceDisplay = {};
				let paymentInfo = res.variants[i].paymentInfo;

				if (variantPrice && variantPrice.isClearancePrice) {
					priceDisplay = {
						'sale': `$ ${variantPrice.salePrice.amount}`,
					};
				}

				if (variantPrice && variantPrice.isDiscountPrice) {
					if (variantPrice.showWasNowFlag) {
						priceDisplay = {
							'origin': `$${variantPrice.listPrice.amount}`,
							'sale': `$${variantPrice.salePrice.amount}`,
						};
					} else {
						priceDisplay = {
							'sale': `$${variantPrice.salePrice.amount}`,
						};
					}
				} else {
					priceDisplay = {
						'sale': `$${variantPrice.salePrice.amount}`,
					};
				}

				variantPrice['priceDisplay'] = priceDisplay;
				That.price[variantCode] = variantPrice;

				if (!That.paymentInfo) That.paymentInfo = {};
				That.paymentInfo[variantCode] = paymentInfo;

				// create the variant slider dom element
				slider.after(`<div class="variant-slider" data-variant-code="${variantCode}"></div>`);
				thumbs.after(`<div class="variant-thumbs" data-variant-code="${variantCode}"></div>`);

				if (variantImages && variantImages.length > 0) {
					// loop through variant images
					// create a slider for each variant

					for (let i = 0; i < variantImages.length; i++) {
						let imgSrc = variantImages[i].detail;
						let imgThumbSrc = variantImages[i].thumb;
						let imgZoomSrc = variantImages[i].zoom;
						let alt = variantImages[i].alt || res.title || '';
						let videoSrc = (res.images && res.images[i] && res.images[i].video) ? res.images[i].video : '';

						let slide = `
							<div class="${CLS}-slide">
								${videoSrc ? '<span class="icon-play"></span>' : ''}
								<img data-zoom-image="${imgZoomSrc}" src="${imgSrc}" alt="${alt}"
									${videoSrc ? 'data-video-src="' + videoSrc + '"' : ''}
								/>
							</div>
						`;
						let thumb = `
							<div class="${CLS}-thumb">
								${videoSrc ? '<span class="icon-play"></span>' : ''}
								<img src="${imgThumbSrc}" alt="${alt}"
									${videoSrc ? 'data-video-src="' + videoSrc + '"' : ''}
								/>
							</div>
						`;

						$pg.find(`.variant-slider[data-variant-code="${variantCode}"]`).append(slide);
						$pg.find(`.variant-thumbs[data-variant-code="${variantCode}"]`).append(thumb);
					}
				}

				// get videos for the current variant
				if (variantVideos && variantVideos.length > 0) {
					for (let i = 0; i < variantVideos.length; i++) {
						let videoSrc = variantVideos[i].source;
						let thumbSrc = variantVideos[i].thumb || variantImages[0].thumb;
						let alt = variantVideos[i].alt || res.title || '';

						let videoThumb = `
							<div class="${CLS}-videoThumb video-player d-none" data-player-variant="${variantCode}" data-src="${videoSrc}">
								<img src="${thumbSrc}" alt="${alt}" />
								<span class="icon-play"><span>
							</div>
						`;
						$pg.find(`.variant-thumbs[data-variant-code="${variantCode}"]`).after(videoThumb);
					}
				}
			}

			// store variants
			That.prodVariants = res.variants;
		}

		That.producItemInfo = res;

		// not sure why it's deleted
		// TODO: investigate this further
		// if (That.producItemInfo && That.producItemInfo['variants']) {
		// 	delete That.producItemInfo['variants'];
		// }

		// set price
		// That.setPrice();

		That.setVisibleProduct();
		That.getVariantCode();

		// just in case it was up
		$('.loading-spinner').removeClass('is-active');

		// END of api call processing

		$pg.on('variantChanged', () => {
			// new variant, change the slider
			// const That = this;
			$pg.find('.product-img').parent().find('.zoomIcon').remove();
			let variantCode = this.isBundles ? this.getCurrentVariantBundle() : $pg.attr('data-variant-code');
			let itemQnty = $pg.find('.quantityInput input').val();
			let slider = $pg.find(PG + 'imgSlider');
			let thumbs = $pg.find(PG + 'imgThumbs');
			let variantSlider = $pg.find(`.variant-slider[data-variant-code="${variantCode}"]`);
			let variantThumbs = $pg.find(`.variant-thumbs[data-variant-code="${variantCode}"]`);

			if (variantSlider.length > 0 && variantThumbs.length > 0) {
				$pg.find('.product-img').addClass('d-none');
				let variantSliderHtml = $pg.find(`.variant-slider[data-variant-code="${variantCode}"]`).html();
				let variantThumbsHtml = $pg.find(`.variant-thumbs[data-variant-code="${variantCode}"]`).html();

				// unslick
				if (slider.hasClass('slick-initialized')) {
					slider.slick('unslick');
				}
				if (thumbs.hasClass('slick-initialized')) {
					thumbs.slick('unslick');
				}
				// add content
				slider.html(variantSliderHtml);
				thumbs.html(variantThumbsHtml);
				// init again
				// generic slick options
				let $sliderOptions = {
					dots: false,
					arrows: true,
					asNavFor: PG + 'imgThumbs',

				};
				let $thumbsOptionsNav = {
					slidesToShow: $pg.find(PG + 'imgSlider').find(PG + 'slide').length,
					slidesToScroll: 1,
					dots: false,
					arrows: false,
					asNavFor: PG + 'imgSlider',
					focusOnSelect: true,

				};
				slider.slick($sliderOptions);
				thumbs.slick($thumbsOptionsNav);
				$pg.find(`[data-player-variant="${variantCode}"]`).each(function() {
					let obj = $(this).clone();
					obj.removeClass('d-none');
					thumbs.find('.slick-track').prepend(obj);
					thumbs.append(`<div class="clearfix"></div>`);
				});
			} else {
				// show an image of the product (generic image / default)
				if (slider.hasClass('slick-initialized')) {
					slider.slick('unslick').empty();
				}
				if (thumbs.hasClass('slick-initialized')) {
					thumbs.slick('unslick').empty();
				}
				// in this case, no zoom image, so, we just use the same image as a fall back
				let imgZoomSrc = $pg.find('.product-img').attr('src');
				$pg.find('.product-img').removeClass('d-none').attr('data-zoom-image', imgZoomSrc);
				$pg.find(`[data-player-variant="${variantCode}"]`).each(function() {
					let obj = $(this).clone();
					obj.removeClass('d-none');
					thumbs.append(obj);
					thumbs.append(`<div class="clearfix"></div>`);
				});
				$pg.find('.product-img').parent().append('<span class="zoomIcon"></span>');
			}

			let productObj = {};
			if (this.isBundles) {
				let selectedBundleItemsArr = [];
				let selectedBundleItems = $('.productDetailsPage-bundlesItem--variant:visible:not(.is-outOfStock)');
				for (let i=0; i < selectedBundleItems.length; i++) {
					let bundleItem = $(selectedBundleItems[i]);
					let code = bundleItem.data('variant-formattedcode');
					let qty = parseFloat(bundleItem.find('.quantityInput input').val());
					if (qty > 0) {
						selectedBundleItemsArr.push({code: code, quantity: qty});
					}
				}
				productObj = {
					code: null,
					quantity: null,
					size: null,
					items: [selectedBundleItemsArr],
				};
			} else {
				productObj = {
					code: variantCode,
					quantity: itemQnty,
					size: $pg.find('.item-size.is-active-variant').text() || '',
				};
			}

			// if we have a variant selected
			if (That.checkSelectedVariant('gtm')) {
				dataLayer.pushProductView(productObj);
			}

			That.checkWishAndGiftLists();
		});
	}

	getCurrentVariantBundle() {
		const $pg = $(this.$el);
		let variantCode = '';
		let optionsColor = $pg.find(PG + 'options.colors .is-active').attr('data-item-description');
		let optionsSize = $pg.find(PG + 'options.sizes .is-active').attr('data-item-description');
		let producItemBundles = $pg.find('.productDetailsPage-bundlesItem--variant');
		let selectedItem;
		if (optionsColor && optionsSize) {
			selectedItem = producItemBundles.filter((index, el) => $(el).attr('data-variant-color') === optionsColor && $(el).attr('data-variant-size') === optionsSize).first();
			if (selectedItem.length) variantCode = $(selectedItem).attr('data-variant-code');
		} else if (optionsColor && !optionsSize) {
			selectedItem = producItemBundles.filter((index, el) => $(el).attr('data-variant-color') === optionsColor).first();
			if (selectedItem.length) variantCode = $(selectedItem).attr('data-variant-code');
		} else if (!optionsColor && optionsSize) {
			selectedItem = producItemBundles.filter((index, el) => $(el).attr('data-variant-size') === optionsSize).first();
			if (selectedItem.length) variantCode = $(selectedItem).attr('data-variant-code');
		}
		return variantCode;
	}

	bannerText(className, text) {
		return `<div class="productItem-labelWrap"><div class="productItem-label productItem-label--${className}"><span>${text}</span></div></div>`;
	}

	showPriceText(className, price, isBold) {
		let isBoldClass = isBold ? 'isBold': '';
		let htmlPrice = `<h4 class="productDetailsPage-${className} ${isBoldClass}">${price}</h4>`;
		return htmlPrice;
	}

	setPrice() {
		const That = this;
		const $pg= $(this.$el);
		let variantCode = $pg.attr('data-variant-code');
		if ($pg.attr('data-generic-sku') && $pg.attr('data-item-type') == 'generic') {
			variantCode = $pg.attr('data-generic-sku');
		}
		let $wrapperPrice = $pg.find(`.${CLS}__price-detail`);
		let $wrapperBannerText = $pg.find(PG + 'productPhoto');
		let priceVariant = That.price && That.price[variantCode];
		let paymentInfoVariant = That.paymentInfo && That.paymentInfo[variantCode];

		// check if there are no options selected, then show the displayPrice instead
		let selectedVariant = true;
		// if no options exist, don't check the add to cart
		let optionsCount = $pg.find('.productDetailsPage-option:visible').length;
		// if no options has been selected
		if (optionsCount > 0) {
			// color only
			let colorOption = $pg.find(`.${CLS}-options.colors .${CLS}-option.is-active.is-active-variant:not(.has-sizes)`);
			// color and size
			let colorSizeOption = $pg.find(`.${CLS}-option.has-sizes.is-active.is-active-variant`);
			// size only
			let sizeOption = $pg.find(`.${CLS}-option.item-size.is-active.is-active-variant`);
			// generic
			let genericOptions = $pg.find(`.${CLS}-option.generic.is-active.is-active-variant`);
			// no variant has been selected
			if (
				colorOption.length == 0 &&
				colorSizeOption.length == 0 &&
				sizeOption.length == 0 &&
				genericOptions.length == 0
			) {
				// return false
				selectedVariant = false;
			} else {
				if (colorSizeOption.length != 0) {
					let parentId = colorSizeOption.attr('data-variant-code');
					let sizeOption = $pg.find('[data-parent-itemid="'+parentId+'"]').find('.productDetailsPage-option.item-size.is-active.is-active-variant');
					if (sizeOption.length == 0) {
						// return false
						selectedVariant = false;
					}
				}
			}
		}

		if (priceVariant && selectedVariant) {
			let clearanceMessage = That.producItemInfo && That.producItemInfo.clearanceMessage;
			const {showWasNowFlag, listPrice, salePrice, isDiscountPrice, isClearancePrice, isPromotionPrice, saleCode} = priceVariant;

			(listPrice.amount) ? listPrice.amount = Number(listPrice.amount).toFixed(2) : null;
			(salePrice.amount) ? salePrice.amount = Number(salePrice.amount).toFixed(2) : null;

			let detailDisplay = '';
			let bannerText = '';
			let originPrice = listPrice.amount? That.showPriceText('normalPrice', `Was $${listPrice.amount}`) : '';
			let nowPrice = salePrice.amount? That.showPriceText('nowPrice', `Now $${salePrice.amount}`) : '';
			let normalPrice = salePrice.amount? That.showPriceText('normalPrice', `$${salePrice.amount}`) : '';
			let nowPriceBold = salePrice.amount? That.showPriceText('nowPrice isBold', `Now $${salePrice.amount}`) : '';

			if (isClearancePrice) {
				detailDisplay = nowPriceBold;
				detailDisplay += `<p class="productItem-subTitle">${clearanceMessage ? clearanceMessage : ''}</p>`;
				bannerText = That.bannerText('clearance', 'CLEARANCE');
			} else if (isDiscountPrice) {
				bannerText = That.bannerText('sale', utils.getDiscountText(saleCode));
				detailDisplay = nowPriceBold;
			} else if (isPromotionPrice) {
				bannerText = That.bannerText('new', `HOT PRICE` );
				if (showWasNowFlag) {
					detailDisplay = originPrice + nowPrice;
				} else {
					detailDisplay = nowPrice;
				}
			} else {
				detailDisplay = normalPrice;
			}

			$wrapperPrice.html(detailDisplay);
			if ($wrapperBannerText.length > 0) {
				if ($wrapperBannerText.find('.productItem-labelWrap').length > 0) {
					let badgeCustom = $wrapperBannerText.find('.productItem-label--custom');
					for (let i=0; i< badgeCustom.length; i++) {
						let bannerHTML = $.parseHTML(bannerText);
						let customElement = ($(badgeCustom[i]))[0].outerHTML;
						if (bannerText) {
							$(bannerHTML).append(customElement);
							bannerText = bannerHTML[0].outerHTML;
						} else {
							bannerText = `<div class="productItem-labelWrap">${customElement}</div>`;
						}
					}
					$wrapperBannerText.find('.productItem-labelWrap').remove();
				}
				if (bannerText) {
					$wrapperBannerText.append(bannerText);
				}
			}

			// prices for partpayment variants
			if (paymentInfoVariant && paymentInfoVariant.length > 0) {
				for (let i = 0; i < paymentInfoVariant.length; i++) {
					$pg.find(`.paymentInfo-detail[data-name="${paymentInfoVariant[i].name}"] .payment-desc`).html(paymentInfoVariant[i].desc);
				}
			}
		} else {
			// show display price
			if (That.displayPrice) {
				$wrapperPrice.html(`<h4>${That.displayPrice}</h4>`);
			}

			// display prices for partpayment variants
			if (That.paymentInfoInit && That.paymentInfoInit.length > 0) {
				for (let i = 0; i < That.paymentInfoInit.length; i++) {
					$pg.find(`.paymentInfo-detail[data-name="${That.paymentInfoInit[i].name}"] .payment-desc`).html(That.paymentInfoInit[i].desc);
				}
			}
		}
	}

	getVariantCode() {
		const $pg = $(this.$el);
		const This = this;
		This.getVariantCodeCall();
	}

	getVariantCodeCall() {
		const That = this;
		const $pg = $(this.$el);
		let itemCode = $pg.data('itemCode');
		let prodType = $pg.attr('data-item-type');
		let colorCode = $pg.find(PG + 'options.colors .is-active-variant').attr('data-variant-code');
		let sizeCode = $pg.find(PG + 'options.sizes .is-active-variant').attr('data-variant-code');
		let colorSku = $pg.find(PG + 'options.colors .is-active-variant').attr('data-sku') || null;
		let sizeSku = $pg.find(PG + 'optionsWrapper:not(.d-none) .sizes .is-active-variant').attr('data-sku') || null;
		let genericSku = $pg.attr('data-generic-sku');

		let $data = {
			'itemCode': itemCode,
			'sizeCode': sizeCode,
			'colorCode': colorCode,
		};

		let variantCode;
		switch (prodType) {
			case 'size':
				variantCode = sizeSku;
				break;
			case 'color':
				variantCode = colorSku;
				break;
			case 'colorsize':
				variantCode = sizeSku;
				break;
			case 'generic':
				variantCode = genericSku;
		}


		// for single product it may not have a variantCode and it will taking from itemCode
		if(variantCode) {
			$pg.attr('data-variant-code', variantCode);
		}
	}

	addToBag(productId, size) {
		const $pg = $(this.$el);
		const This = this;
		const $error = $pg.find('.error-messages.add-to-cart-errors');
		const isFitFunction = productId ? true : false;
		// toggle spinners
		$('.loading-spinner').addClass('is-active');

		// reset the error msg
		$error.text('');
		$error.removeClass('is-active');

		if (This.checkSelectedVariant('cart', isFitFunction)) {
			// check for bundles and see if a bundle item is selected
			/* OLD BUNDLUES FEATURES
			let bundleItems = $pg.find('.bundle-item-checkbox');
			if (bundleItems.length > 0) {
				let selectedBundleItems = $pg.find('.bundle-item-checkbox:checked');
				if (selectedBundleItems.length == 0) {
					$pg.find('.error-messages.bundle-add-to-cart-errors').addClass('is-active').text('Please select at least one bundle item before adding to cart');
					$('.loading-spinner').removeClass('is-active');
					return;
				} else {
					$pg.find('.error-messages.bundle-add-to-cart-errors').removeClass('is-active').text('');
				}
			}
			*/

			let prop = this.prepareProductProp(productId, size);
			addToCart(prop, () => {
				// success callback
				setTimeout(function() {
					$('.loading-spinner').removeClass('is-active');
				}, 500);
			}, (data) => {
				// fail callback
				// show error div
				$error.addClass('is-active').text(data.message);
				$('.loading-spinner').removeClass('is-active');
			});
		} else {
			return;
		}
	}

	prepareProductProp(productId, size) {
		let selectedBundleItemsArr = [];
		let itemCode = this.$pg.attr('data-variant-code');
		if (this.prodType == 'generic') {
			itemCode = this.$pg.attr('data-generic-sku');
		}

		let itemQnty = '1';
		if (!productId) {
			itemQnty = this.$pg.find('.quantityInput input').val();
		}
		let data = {
			'code': productId || itemCode,
			'quantity': itemQnty,
		};

		// bundles add to cart
		/* OLD BUNDLES
		let bundleItems = this.$pg.find('.bundle-item-checkbox');
		if (bundleItems.length > 0) {
			let selectedBundleItems = this.$pg.find('.bundle-item-checkbox:checked');
			selectedBundleItems.each(function() {
				let code = $(this).data('code');
				selectedBundleItemsArr.push(code);
			});
			data['code'] = selectedBundleItemsArr;
			this.bundleAddToCart = true;
		}*/


		// push data to dataLayer to Google Tag Manager
		let productObj = {};
		if (this.isBundles) {
			// add to cart for bundles
			let selectedBundleItems = $('.productDetailsPage-bundlesItem--variant:visible:not(.is-outOfStock)');
			for(let i=0; i < selectedBundleItems.length; i++) {
				let bundleItem = $(selectedBundleItems[i]);
				let code = bundleItem.data('variant-formattedcode');
				let qty = parseFloat(bundleItem.find('.quantityInput input').val());
				if(qty > 0) {
					selectedBundleItemsArr.push({code: code, quantity: qty});
				}
			}
			productObj = {
				code: null,
				quantity: null,
				size: null,
				items: [selectedBundleItemsArr]
			};
			data['items'] = selectedBundleItemsArr;
			this.bundleAddToCart = true;
			dataLayer.pushAddToCart(productObj);

		} else {
			// add to cart productdetails
			let productObj = {
				code: itemCode,
				quantity: itemQnty,
				size: this.$pg.find('.item-size.is-active-variant').text() || '',
			};

			dataLayer.pushAddToCart(productObj);
		}

		this.bundleAddToCart = false;

		return {
			endpoint: this.isBundles ? $('.endpoints-definition').data('add-to-cart-bundle-endpoint') : $('.endpoints-definition').data('add-to-bag-endpoint') || '',
			code: data.code,
			quantity: data.quantity,
			size: size || data.size || '',
			datalayerDataSource: '',
			title: this.$pg.find('.prod-title').text() || '',
			cartLink: this.$pg.data('cartLink') || '#',
			prodImg: this.$pg.find('.product-img').attr('src') || '',
			items: data.items,
			isBundles: this.isBundles,
		};
	}

	subscribeToNewsletter() {
		const $pg = $(this.$el);
		const This = this;
		// toggle spinners
		$('.loading-spinner').addClass('is-active');

		This.subscribeToNewsletterCall().then((data) => {
			if (data.result == 'SUCCESS') {
				$pg.find('.newsletter .success-messages').addClass('is-active').text(data.message);
				$pg.find('.newsletter input, .newsletter button[type="submit"]').prop('disabled', true);
				// toggle spinners
				$('.loading-spinner').removeClass('is-active');
			} else {
				// show error div
				$pg.find('.newsletter .error-messages').addClass('is-active').text(data.message);
				$('.loading-spinner').removeClass('is-active');
			}
		});
	}

	subscribeToNewsletterCall() {
		const $pg = $(this.$el);
		let $email = $pg.find('#email').val();
		let $subscribeEndpoint = $pg.find('form.newsletter').attr('action');
		let $data = {
			'email': $email,
		};
		return Api.callApi($subscribeEndpoint, $data);
	}

	initFormValidationConstraints() {
		let $form = $(this.$el).find('form.newsletter');
		if ($form.length > 0) {
			utils.formValidation($form[0], this);
		}
	}

	formSuccessCallback(form) {
		let This = this;
		// check form type
		if ($(form).hasClass('newsletter')) {
			// api call
			This.subscribeToNewsletter();
		} else {
			$(form).submit();
		}
	}

	showPopper(data) {
		// register the template
		let partial = require('../../../widgets/notifications/tmpl/notifications.hbs');
		Handlebars.registerPartial('notifications', partial);
		let theTemplateScript = `
			{{> notifications wg="notifications" ns="Notifications" }}
		`;
		let precompiled = new Function('return ' + Handlebars.precompile(theTemplateScript))();
		let theTemplate = Handlebars.template(precompiled);
		let theCompiledHtml = theTemplate(data);
		$(document).find('body').append(theCompiledHtml);
		// Re-init script for notifications widget
		loadNotifications(document.body, false, true).then((wg) => {
			wg ? wg.init(data.recommendationsApi) : '';
		}).catch((error) => `${error} An error occurred while loading notifications script`);
	}

	handleCloseImgViewer(imgViewer, sliderHolder, thumbsHolder ) {
		imgViewer.removeClass('is-active');
		if (sliderHolder.hasClass('slick-initialized')) {
			sliderHolder.slick('unslick');
		}
		if (thumbsHolder.hasClass('slick-initialized')) {
			thumbsHolder.slick('unslick');
		}
		// destroy all prev zoom stuff
		sliderHolder.find('.zoom').each(function() {
			$(this).trigger('zoom.destroy');
		});
		// empty html
		sliderHolder.html('');
		thumbsHolder.html('');
	}

	setImageViewer() {
		const That = this;
		const $pg = $(this.$el);
		let imgViewer = $pg.find(PG + 'imageViewer');
		let closeImgViewer = imgViewer.find('.icon-close');
		let sliderHolder = imgViewer.find('.slider-holder');
		let thumbsHolder = imgViewer.find('.thumbs-holder');
		let zoomMsg = 'Tap and move your finger around the image to zoom';

		// get clicks on the close icon
		closeImgViewer.on('click', function() {
			That.handleCloseImgViewer(imgViewer, sliderHolder, thumbsHolder );
		});

		// get clicks on product images / slider images
		$pg.on('click', `${PG}imgSlider .slick-slide, .product-img`, function() {
			let currenSlideIndex = Number($(`${PG}imgThumbs .slick-slide.slick-current`).attr('data-slick-index'));

			// toggle the image view
			imgViewer.addClass('is-active');
			// show spinners
			$('.loading-spinner').addClass('is-active');
			// check if it's a static image without a slider
			let imageCheck = $(this).hasClass('product-img');
			let $target = $(this);
			let isImg = this.tagName === 'IMG';
			if (!isImg) {
				$target = $(this).find('img');
			}

			let targetVideoSrc = $target.data('video-src') || '';

			if (imageCheck) {
				let zoomImg = $(this).data('zoomImage') || $(this).attr('src');
				let alt = $(this).attr('alt') || $pg.find('.prod-title').text() || '';
				sliderHolder.append(`<span class="message-zoom">${zoomMsg}</span><span class="zoom"><img src="${zoomImg}" alt="${alt}" /></span>`);
				sliderHolder.addClass('is-fullHeight');
				thumbsHolder.hide();
				$('.loading-spinner').removeClass('is-active');
			} else {
				sliderHolder.removeClass('is-fullHeight');
				thumbsHolder.show();
				// fill up the slider and thumbs area
				let slides = $pg.find(PG + 'imgSlider');
				let thumbs = $pg.find(PG + 'imgThumbs');
				slides.find('.slick-slide:not(.slick-cloned) img').each(function() {
					let $img = $(this);
					let zoomImg = $img.data('zoomImage') || $img.attr('src');
					let alt = $img.attr('alt') || $pg.find('.prod-title').text() || '';
					let videoSrc = $img.data('video-src') || '';
					let tmpl = '';

					if (videoSrc) {
						tmpl = `
							<div>
								<div class="${CLS}-videoZoomWrap">
									<video class="${CLS}-videoZoom" controls="controls" src="${videoSrc}"></video>
								</div>
							</div>
						`;
					} else {
						tmpl = `
							<div>
								<span class="message-zoom">${zoomMsg}</span>
								<span class="zoom">
									<img src="${zoomImg}" alt="${alt}" />
								</span>
							</div>
						`;
					}

					sliderHolder.append(tmpl);
				});

				thumbs.find('.slick-slide:not(.slick-cloned) img').each(function() {
					let $img = $(this);
					let thumbImg = $img.attr('src');
					let alt = $img.attr('alt') || $pg.find('.prod-title').text() || '';
					let videoSrc = $img.data('video-src') || '';
					let tmpl = `
						<div class="${CLS}-imgZoomWrap">
							${videoSrc ? '<span class="icon-play"></span>' : ''}
							<img src="${thumbImg}" alt="${alt}" />
						</div>
					`;
					thumbsHolder.append(tmpl);
				});

				// generic slick options
				let $sliderOptions = {
					// infinite: false,
					dots: false,
					arrows: true,
					asNavFor: '.thumbs-holder',
					initialSlide: currenSlideIndex,
					responsive: [
						{
							breakpoint: 786,
							settings: {
								touchMove: false,
								swipe: false,
							},
						},
					],
				};

				let $thumbsOptionsNav = {
					slidesToShow: Math.floor($(window).width() / 80),
					dots: false,
					arrows: true,
					asNavFor: '.slider-holder',
					focusOnSelect: true,
					touchMove: false,
					initialSlide: currenSlideIndex,
					responsive: [
						{
							breakpoint: 768,
							settings: {
								touchMove: false,
								swipe: false,
							},
						},
					],
				};

				// wait for all images to load
				// then init sliders

				let images = sliderHolder.find('img');
				let imagesLoaded = 0;
				let totalImages = images.length;

				sliderHolder.off().on('init', () => {
					$('.loading-spinner').removeClass('is-active');
					// if (targetVideoSrc) {
					// 	$(`.${CLS}-videoZoom`).trigger('play');
					// }
				});

				images.each(function() {
					let imgSrc = $(this).attr('src');
					let objImg = new Image();
					objImg.src = imgSrc;
					objImg.onload = function() {
						imagesLoaded++;
						if (imagesLoaded == totalImages) {
							// init slides
							sliderHolder.slick($sliderOptions);
							thumbsHolder.slick($thumbsOptionsNav);
						}
					};
				});

				sliderHolder.on('beforeChange', () => {
					$(`.${CLS}-videoZoom`).trigger('pause');
				});

				// init zoom
				if (sliderHolder.find('.zoom').length > 0) {
					if (utils.isOnMobileSmaller()) {
						sliderHolder.find('.zoom').each(function() {
							$(this).closest(PG + 'imageViewer').addClass('zoomWrapper');
							let zoomImg = $(this).find('img').attr('src');
							$(this).zoom({
								on: 'grab',
								url: zoomImg,
								magnify: 1.2,
							});
						});
					}
				}

				// re-calculate width
				$(window).trigger('resize');
			}
		});

		// $(window).trigger('resize');

		$(window).on('resize', function() {
			if (utils.isOnMobileSmaller()) {
				sliderHolder.find('img').not('.zoomImg').css({
					'max-height': sliderHolder.height() - 100,
				});
			} else {
				sliderHolder.find('img').not('.zoomImg').attr('style', '');
			}
		});

		// handle click outside
		imgViewer.on('click', '.slider-holder', function(event) {
			if ($(event.target).closest(`.zoom, .${CLS}-videoZoom`).length === 0 && $(event.target).closest(`.slick-arrow`).length !== 1) {
				That.handleCloseImgViewer(imgViewer, sliderHolder, thumbsHolder);
			}
		});
	}

	handleWishlistBtn($btn) {
		const $pg = $(this.$el);
		const This = this;
		let code = $pg.attr('data-variant-code');
		let qty = $pg.find('.quantityInput input').val();

		if (This.prodType == 'generic') {
			code = $pg.attr('data-generic-sku');
		}

		let param = {
			code: code,
			qty: qty,
		};

		// check if is already added to wishlist
		if (!$btn.hasClass(CLS_LIST_ADDED)) {
			if (!This.checkSelectedVariant('wishlist')) return;

			let addEnpoint = $pg.data('addToWishlistEndpoint');
			window.itemTitle = $pg.find('.prod-title').text();
			window.itemImg = $pg.find('.product-img').attr('src');
			wishlist.add($pg, $btn, addEnpoint, param);
		} else {
			let removeEnpoint = $pg.data('removeFromWishlistEndpoint');
			wishlist.remove($pg, $btn, removeEnpoint, param);
		}
	}

	addToGiftRegistry($btn) {
		const $pg = $(this.$el);
		const This = this;
		let code = $pg.attr('data-variant-code');
		let qty = $pg.find('.quantityInput input').val();
		let addEnpoint = $pg.data('addToGiftRegistryEndpoint');

		if (This.prodType == 'generic') {
			code = $pg.attr('data-generic-sku');
		}

		if (!This.checkSelectedVariant('gift registry')) return;

		let param = {
			id: code,
			quantity: qty,
		};

		giftRegistry.add($pg, addEnpoint, param, (data) => {
			let res = data.response;
			let details = {
				mods: data.message ? 'has-error' : '',
				title: $pg.find('.prod-title').text(),
				addedText: 'Added to gift registry',
				qty: data.quantityActual,
				itemImg: $pg.find('.product-img').attr('src'),
				errorMsg: data.message,
				recommendationsApi: utils.getRecommendationsApi(res.recommendationsApi || ''),
				recommendationsTitle: res.recommendationsTitle || '',
				recommendationsViewMoreLink: res.recommendationsViewMoreLink || '',
				recommendationsProducts: data.code
			};
			This.showPopper(details);

			if (data.result == 'SUCCESS') {
				$btn.addClass(CLS_LIST_ADDED);
			} else {
				$btn.removeClass(CLS_LIST_ADDED);
			}
		});
	}

	checkSelectedVariant(state, isFA) {
		if (isFA) return true;
		const This = this;
		const $pg = $(this.$el);
		let errorDiv = $pg.find('.error-messages.add-to-cart-errors');
		let errorMsg = `Please select product options before adding this product to your ${state}`;
		let errorQtyMsg = this.isBundles ? `Please select at least one bundle item before adding to ${state}` : `Please select at least one item before adding to ${state}`;

		// reset errors
		errorDiv.removeClass('is-active').text('');

		// if no options exist, don't check the add to cart
		let optionsCount = $pg.find('.productDetailsPage-option:visible').length;
		// if no options has been selected
		if (optionsCount > 0) {
			// color only
			let colorOption = $pg.find(`.${CLS}-options.colors .${CLS}-option.is-active.is-active-variant:not(.has-sizes)`);
			// color and size
			let colorSizeOption = $pg.find(`.${CLS}-option.has-sizes.is-active.is-active-variant`);
			// size only
			let sizeOption = $pg.find(`.${CLS}-option.item-size.is-active.is-active-variant`);
			// generic
			let genericOptions = $pg.find(`.${CLS}-option.generic.is-active.is-active-variant`);

			// no variant has been selected
			if (!colorOption.length && !colorSizeOption.length && !sizeOption.length && !genericOptions.length) {
				// show error message
				this.showErrorMessage(state, errorDiv, errorMsg);
			} else {
				if (this.isBundles) {
					// only for bundle
					let bundleColorOption = $pg.find(`.${CLS}-options.colors`);
					let bundleSizeOption = $pg.find(`.${CLS}-options.sizes`);

					if (bundleColorOption.length || bundleSizeOption.length) {
						if ( (bundleColorOption.length && bundleSizeOption.length ) &&
							(!bundleColorOption.find('.is-active').length || !bundleSizeOption.find('.is-active').length)) {
								// show error message
								this.showErrorMessage(state, errorDiv, errorMsg);
						} else if ((bundleColorOption.length && !bundleSizeOption.length) && !bundleColorOption.find('.is-active').length) {
								// show error message
								this.showErrorMessage(state, errorDiv, errorMsg);
						} else if ((!bundleColorOption.length && bundleSizeOption.length) && !bundleSizeOption.find('.is-active').length) {
								// show error message
								this.showErrorMessage(state, errorDiv, errorMsg);
						} else {
							if ($(PG + 'bundlesItem.productItem:visible').length) {
								if (this.hasSelectedProductQuantity())
									return true;
								else {
									// show error message
									this.showErrorMessage(state, errorDiv, errorQtyMsg);
								}
							} else {
								$('.loading-spinner').removeClass('is-active');
								errorDiv.addClass('is-active').text(errorMsg);
								This.scrollToErrorMessage(errorDiv);
								return false;
							}
						}
					} else {
						if ($(PG + 'bundlesItem.productItem:visible').length) {
							if (this.hasSelectedProductQuantity())
								return true;
							else {
								// show error message
								this.showErrorMessage(state, errorDiv, errorQtyMsg);
							}
						} else {
							$('.loading-spinner').removeClass('is-active');
							errorDiv.addClass('is-active').text(errorMsg);
							This.scrollToErrorMessage(errorDiv);
							return false;
						}
					}
				} else {
					// for product details
					if (colorSizeOption.length != 0) {
						let parentId = colorSizeOption.attr('data-variant-code');
						let sizeOption = $pg.find('[data-parent-itemid="'+parentId+'"]').find('.productDetailsPage-option.item-size.is-active.is-active-variant');
						if (sizeOption.length == 0) {
							// show error message
							this.showErrorMessage(state,errorDiv, errorMsg);
						} else {
							if(this.hasSelectedProductQuantity())
								return true;
							else {
								// show error message
								this.showErrorMessage(state,errorDiv, errorQtyMsg);
							}
						}
					} else {
						if(this.hasSelectedProductQuantity())
							return true;
						else {
							// show error message
							this.showErrorMessage(state,errorDiv, errorQtyMsg);
						}
					}
				}
			}
		} else {
			if(this.hasSelectedProductQuantity())
				return true;
			else {
				// show error message
				this.showErrorMessage(state,errorDiv, errorQtyMsg);
			}
		}
	}

	setAppearanceBundlesVariants() {
		// only for bundles
		if (this.isBundles) {
			const $pg = $(this.$el);
			let optionsColorsWrapper = $pg.find(PG + 'options.colors');
			let optionsSizesWrapper = $pg.find(PG + 'options.sizes');
			let producItemBundles = $pg.find(PG + 'bundlesItem.productItem');

			// reset the previous selected
			producItemBundles.find(PG + 'bundlesItem--variant.is-outOfStock .productDetailsPage-bundlesItem-price').removeClass('d-none');
			producItemBundles.find(PG + 'bundlesItem--variant.is-outOfStock').removeClass('is-outOfStock');
			producItemBundles.find('.productItem-label-outofstock').remove();
			producItemBundles.find('input[type="number"].form-control').val(0);
			producItemBundles.find('.quantityInput-up.btn-up').removeClass('disabled');
			producItemBundles.find('.quantityInput-down.btn-down').addClass('disabled');
			producItemBundles.find('input[type="number"].form-control').prop('disabled', false);

			if (optionsColorsWrapper.length && optionsSizesWrapper.length) {
				// for bundle with have Colors and Sizes option
				let optionColorsActive = optionsColorsWrapper.find(PG + 'option.is-active');
				let optionSizesActive = optionsSizesWrapper.find(PG + 'option.is-active');

				if (optionColorsActive.length && optionSizesActive.length) {
					let $colorSelectedCode = $(optionColorsActive).attr('data-item-description');
					let $sizeSelectedCode = $(optionSizesActive).attr('data-item-description');

					for (let i=0; i< producItemBundles.length; i++) {
						let That = $(producItemBundles[i]);
						let bundleVariant = That.find(PG + 'bundlesItem--variant');
						for ( let a=0; a < bundleVariant.length; a++) {
							let $elem = $(bundleVariant[a]);
							let $elemVarColor = $elem.attr('data-variant-color');
							let $elemVarSize = $elem.attr('data-variant-size');

							if ($elemVarColor !== 'undefined' && $elemVarSize !== 'undefined') {
								if ($elemVarColor == $colorSelectedCode && $elemVarSize == $sizeSelectedCode ) {
									That.find(PG + 'bundlesItem--variant').addClass('d-none');
									$elem.removeClass('d-none');
								} else {
									this.setOutOfStock($elem);
								}
							} else {
								if ($elemVarColor !== 'undefined' && $elemVarSize == 'undefined') {
									if ($elemVarColor !== $colorSelectedCode ) {
										this.setOutOfStock($elem);
									} else {
										That.find(PG + 'bundlesItem--variant').addClass('d-none');
										$elem.removeClass('d-none');
									}
								} else if ($elemVarColor== 'undefined' && $elemVarSize !== 'undefined') {
									if ($elemVarSize !== $sizeSelectedCode ) {
										this.setOutOfStock($elem);
									} else {
										That.find(PG + 'bundlesItem--variant').addClass('d-none');
										$elem.removeClass('d-none');
									}
								}
							}
						}
					}
				}
			} else if (optionsColorsWrapper.length && !optionsSizesWrapper.length) {
				// for bundle with have only have Colors option
				let optionColorsActive = optionsColorsWrapper.find(PG + 'option.is-active');
				if (optionColorsActive.length) {
					let $colorSelectedCode = $(optionColorsActive).attr('data-item-description');
					for(let i=0; i< producItemBundles.length; i++) {
						let That = $(producItemBundles[i]);
						let bundleVariant = That.find(PG + 'bundlesItem--variant');
						for( let a=0; a < bundleVariant.length; a++) {
							let $elem = $(bundleVariant[a]);
							let $elemVarColor = $elem.attr('data-variant-color');
							if($elemVarColor !== "undefined") {
								if($elemVarColor == $colorSelectedCode ) {
									That.find(PG + 'bundlesItem--variant').addClass('d-none');
									$elem.removeClass('d-none');
								}else {
									this.setOutOfStock($elem);
								}
							}
						}
					}
				}
			} else if(!optionsColorsWrapper.length && optionsSizesWrapper.length) {
				// for bundle with have only have Sizes option
				let optionSizesActive = optionsSizesWrapper.find(PG + 'option.is-active');
				if (optionSizesActive.length) {
					let $sizeSelectedCode = $(optionSizesActive).attr('data-item-description');
					for(let i=0; i< producItemBundles.length; i++) {
						let That = $(producItemBundles[i]);
						let bundleVariant = That.find(PG + 'bundlesItem--variant');
						for( let a=0; a < bundleVariant.length; a++) {
							let $elem = $(bundleVariant[a]);
							let $elemVarSize = $elem.attr('data-variant-size');
							if($elemVarSize !== "undefined") {
								if($elemVarSize == $sizeSelectedCode ) {
									That.find(PG + 'bundlesItem--variant').addClass('d-none');
									$elem.removeClass('d-none');
								}else {
									this.setOutOfStock($elem);
								}
							}
						}
					}
				}
			}

			// payment info
			this.calculatePaymentInfo();
			// Disable Add to cart if all products is out of stock
			this.handleAddToCartOOS();
		}
	}

	handleAddToCartOOS() {
		const $pg = $(this.$el);
		let producItemBundles = $pg.find(PG + 'bundlesItem.productItem');
		let optionColor = $pg.find(PG + 'options.colors .productDetailsPage-option.is-active');
		let optionSize = $pg.find(PG + 'options.sizes .productDetailsPage-option.is-active');
		let isNotInStock = $(optionColor).hasClass('is-notInStock') && optionSize.length ? true : false;
		let currentList = producItemBundles.find(PG + 'bundlesItem--variant:not(.d-none)');
		let numberOutOfStock = 0;
		for (let i = 0; i < currentList.length; i ++) {
			let labels = $(currentList[i]).find('.productItem-label');
			let outOfStocks = labels.filter((i, el) => $(el).text() === 'OUT OF STOCK');
			if (outOfStocks.length) {
				numberOutOfStock ++;
			}
		}
		let btnAddToCart = $pg.find('.add-to-cart');
		if (numberOutOfStock === producItemBundles.length || isNotInStock) {
			$(btnAddToCart).prop('disabled', true);
		} else {
			if ($(btnAddToCart).attr('disabled')) {
				$(btnAddToCart).removeAttr('disabled');
			}
		}
	}

	scrollToErrorMessage(errorDiv) {
		if (errorDiv.length > 0) {
			$('html, body').animate({
				scrollTop: errorDiv.offset().top - $(document).find('.siteHeader').height() - 16, // a bit of a margin
			});
		}
	}

	checkWishAndGiftLists() {
		const That = this;
		const $pg = $(this.$el);
		let variant = $pg.attr('data-variant-code');

		if (variant && variant != '') {
			// get wishList and giftList states for the selected variant
			That.getVariantWishListAndGiftState(variant).then((data) => {
				if (data.result == 'SUCCESS') {
					That.variantStates = data.response;
					That.handleWishListAndGiftVariantObj();
				}
			});
		}
	}

	getVariantWishListAndGiftState(variant) {
		let $endpoint = $(this.$el).data('getWishlistGiftlistStatesEndpoint');
		return Api.getApi($endpoint + variant);
	}

	handleWishListAndGiftVariantObj() {
		const That = this;
		const $pg = $(this.$el);
		let variantObj = That.variantStates;

		if (variantObj.isAddedIntoGiftRegistry) {
			$pg.find('.addToGiftBtn').addClass(CLS_LIST_ADDED);
		} else {
			$pg.find('.addToGiftBtn').removeClass(CLS_LIST_ADDED);
		}

		if (variantObj.isAddedIntoWishlist) {
			$pg.find('.wishlistBtn').addClass(CLS_LIST_ADDED);
		} else {
			$pg.find('.wishlistBtn').removeClass(CLS_LIST_ADDED);
		}
	}

	setReviews() {
		const $pg = $(this.$el);

		let options = {
			page: 10,
			pagination: [{
				name: 'pagination-top',
				paginationClass: 'pagination-top',
				innerWindow: 4,
			}, {
				paginationClass: 'pagination-bottom',
				innerWindow: 4,
			}],
		};

		this.list = new List('reviewsList', options);
		this.setPaginationPrev();
		this.setPaginationNext();


		const totalPages = $pg.find('.pagination-top li').length;

		if (!totalPages || totalPages < 2) {
			$pg.find(PG + 'reviewsSec-paging').addClass('d-none');
		}

		this.list.on('updated', () => {
			this.scrollToTop();
		});
	}

	getPageIndexes() {
		const page = this;
		const total = page.$el.querySelectorAll('.pagination-top .page').length;
		const current = parseInt(page.$el.querySelector('.pagination-top .active .page').innerText);
		const prev = current > 1 ? current - 1 : null;
		const next = current < total ? current + 1 : null;
		return {total, current, prev, next};
	}

	setPaginationPrev() {
		const that = this;
		$('.pagination-prev').on('click', function(e) {
			const pageIndexes = that.getPageIndexes();
			const totalItems = that.list.page;
			const index = ((pageIndexes.current - 1) * totalItems) - totalItems + 1;
			pageIndexes.prev ? that.list.show(index, 10) : '';

			that.scrollToTop();
		});
	}

	setPaginationNext() {
		const that = this;
		$('.pagination-next').on('click', function(e) {
			const pageIndexes = that.getPageIndexes();
			const totalItems = that.list.page;
			const index = ((pageIndexes.current - 1) * totalItems) + totalItems + 1;
			pageIndexes.next ? that.list.show(index, 10) : '';

			that.scrollToTop();
		});
	}

	scrollToTop() {
		$('html, body').animate({
			scrollTop: $(PG + 'reviewsSec').offset().top,
		}, 500);
	}

	calculatePaymentInfo() {
		let $pg = $(this.$el);
		let $price = 0;
		let activeSelectedBundles = $pg.find(PG + 'bundlesItem--variant:not(.d-none)');
		activeSelectedBundles.each((i, a)=> {
			let $el = $(a);
			let $qty = parseFloat($el.find('input[type="number"].form-control').val());
			let $elPrice = parseFloat($el.data('variant-price'));
			if($qty > 0) {
				$price = $price + ($elPrice * $qty);
			}
		});
		let obj = $pg.find(PG + 'optionsWrapper--selectItems').data('payment-info');
		let productDetailsPagePaymentInfo = $pg.find(PG + 'paymentInfo');
		for (let [key, value] of Object.entries(obj)) {
			if ($price > 0) {
				productDetailsPagePaymentInfo
					.find(`.paymentInfo-detail[data-name="${key}"]`)
					.find('.payment-desc strong').html(`${($price/value).toFixed(2)}`);
			}else {
				productDetailsPagePaymentInfo
					.find(`.paymentInfo-detail[data-name="${key}"]`)
					.find('.payment-desc strong').html('0.00');
			}
		}
	}

	setOutOfStock($element) {
		let labelWrap = $element.find('.productItem-labelWrap');
		let price = $element.find('.productDetailsPage-bundlesItem-price');
		$element.addClass('is-outOfStock');
		$element.find('.quantityInput-up.btn-up, .quantityInput-down.btn-down').addClass('disabled');
		$element.find('input[type="number"].form-control').prop('disabled', true);
		if (!labelWrap.find('.productItem-label-outofstock').length) {
			labelWrap.append('<div class="productItem-label productItem-label--default productItem-label-outofstock"><span>OUT OF STOCK</span></div>');
			price.addClass('d-none');
		}
	}

	initBundlesQtyButtons() {
		if(this.isBundles){
			let $pg = $(this.$el);
			$pg.find('.quantityInput-up.btn-up, .quantityInput-down.btn-down').on('click', () => {
				this.calculatePaymentInfo();
			});
		}
	}

	hasSelectedProductQuantity() {
		let $pg = $(this.$el);
		let qty = 0;
		let activeSelectedBundles = $pg.find('.quantityInput input[type="number"].form-control:visible');
		activeSelectedBundles.each((i, a)=> {
			let $qty = parseFloat($(a).val());
			qty = qty + $qty;
		});
		if (qty > 0)
			return true;
		else
			return false;
	}

	showErrorMessage(state, errorDiv, errorMsg) {
		const that = this;
		if (state !== 'gtm') {
			errorDiv.addClass('is-active').text(errorMsg);
			$('.loading-spinner').removeClass('is-active');
			that.scrollToErrorMessage(errorDiv);
		}
		return false;
	}
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_06/_work/151/s/FrontEnd/src/views/pages/productDetailsPage/js/productDetailsPage.js